import { defineComponent as _defineComponent } from 'vue'
import ResourceContributorCard from './ResourceContributorCard.vue';
import { Resource } from '~/types/resource';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResourceContributors',
  props: {
    resource: null
  },
  setup(__props: any) {



return { __sfc: true,ResourceContributorCard }
}

})